import React from "react";
import { Helmet } from "react-helmet-async";
import { observer, inject } from "mobx-react";
import { useParams } from "react-router-dom";
import { pipe } from "Utils";
import useDefaultParams from "Services/useDefaultParams";
import { generateUrl } from "Services/withDefaultParams";
import configRoutes from "Configs/routes";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import { SitemapContainer } from "Containers/Sitemap";
import { ContainerPaddingBottom } from "ComponentsUI/Spacings";
import { Redirect404 } from "ComponentsUI/Redirects";

const SiteMap = (props) => {
	const {
		ApplicationModel: { currentRegion, siteConfig },
		route,
	} = props;
	const routeParams = useParams();
	const { regionUrl } = useDefaultParams(routeParams);

	if (regionUrl && regionUrl !== currentRegion?.url) {
		return <Redirect404 message404={`Несовпадение regionUrl: ${regionUrl}`} />;
	}

	const canonical = () => {
		let location = generateUrl(configRoutes.SiteMap.route, {
			regionUrl: regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	return (
		<>
			{canonical()}
			<ContainerPaddingBottom>
			<SeoBlockHOC route={route} placeText="Sitemap">
				<SitemapContainer />
			</SeoBlockHOC>
			</ContainerPaddingBottom>
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"))(SiteMap);
